import { Component, OnInit } from '@angular/core';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { SignInDto } from '../../../../dtos/sign-in.dto';
import { AuthServiceService } from '../../../../shared-services/auth-service.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-social-login',
    templateUrl: './social-login.component.html',
    styleUrls: ['./social-login.component.scss']
})
export class SocialLoginComponent implements OnInit {

    @Output()
    validationOutput: EventEmitter<any> = new EventEmitter<any>();

    constructor(private authService: AuthServiceService, private userService: UserService) {
    }

    ngOnInit(): void {
    }

    facebookLogin() {
        window['FB'].login((response) => {
            let signInDto = new SignInDto();
            signInDto.accessToken = response.authResponse.accessToken;
            signInDto.facebook = true;
            this.socialValidation(signInDto);
        });
    }


    googleLogin() {
        this.authService.auth2.signIn().then((response) => {
            let signInDto = new SignInDto();
            signInDto.accessToken = response.getAuthResponse().id_token;
            signInDto.google = true;
            this.socialValidation(signInDto);
        })
    }

    socialValidation(signInDto) {
        this.userService.validateUser(signInDto)
            .then((noValid: boolean) => {
                this.validationOutput.emit(noValid);
            })
    }


}
